module.exports = __webpack_public_path__ + "static/105ae52d-c54d-402b-8e75-b58d86dcc41f-1c27d90e11b3b7f6b94a934269a27107.webp";